import type { DexieOutboxRepository } from '../infrastructure/dexie-outbox.repository.js';

/**
 * acknowledgeDurableWarning (pwa-offline-first Slice 7 MEDIUM fix —
 * adversarial review) — the "acknowledge" action for `/pending`'s "needs a
 * look" section (dropped-incident-photos / clamped-checkin-time durable
 * warnings, see `hasDurableWarning`). Stamps `acknowledgedAt` directly via
 * the repository (NOT `transition()` — this is metadata about operator
 * review, not a state-machine event; the item's `state` stays `synced`)
 * so the row drops out of that section on this and every future render,
 * WITHOUT deleting it — it is kept for audit like any other synced row,
 * subject to the SAME 7-day retention `purge-old-outbox.ts` already
 * applies to every synced/discarded row.
 *
 * Throws when the item does not exist, same "never silently no-op"
 * philosophy as `resolveRejected` (resolve-rejected.ts) — a caller acting
 * on a row it just saw on screen should always know if that write failed
 * to land.
 */
export async function acknowledgeDurableWarning(
  repo: Pick<DexieOutboxRepository, 'get' | 'update'>,
  itemId: string,
): Promise<void> {
  const item = await repo.get(itemId);
  if (!item) {
    throw new Error(`acknowledgeDurableWarning: no outbox item with id "${itemId}"`);
  }
  await repo.update(itemId, { acknowledgedAt: new Date().toISOString() });
}
